module.exports = __webpack_public_path__ + "fb6eb37a4a539398103224a06dfb67f6.png";